/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner';

/**
* Counters for the different categories of resources that have been backed up
*/
export class BackedUpByResourceType {
  'data'?: Array<BackedUpByResourceTypeDataInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<BackedUpByResourceTypeDataInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackedUpByResourceType.attributeTypeMap;
  }

  public constructor() {
  }
}

